import React from 'react';
import ContentHeader from '../../../components/ContentHeader/ContentHeader';
import { Grid, Typography, Paper, LinearProgress, Button } from '@material-ui/core';

export default function LoadingMirror({ loadingMirrorMessage, buttonLoadingMirrorMessage, closeLoadingMirror }) {

    return (
        <ContentHeader
            title="Relatório Espelho de Ponto"
            subtitle="Selecione o período e os funcionários para gerar o relatório de pontos"
        >
            <Paper elevation={2} style={{ width: '100%', height: '60%', paddingTop: '20px' }}>
                <Grid style={{ width: '100%', height: '60%', padding: '20px' }}>
                    <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {loadingMirrorMessage ? loadingMirrorMessage : 'Seu espelho está sendo gerado. Isso pode levar alguns minutos, mas fique tranquilo, estamos trabalhando para entregá-lo o mais rápido possível.'}
                    </Typography>
                </Grid>
                {!buttonLoadingMirrorMessage ?
                    <LinearProgress style={{ paddingTop: '10px' }} />
                    : ''
                }
                {!buttonLoadingMirrorMessage ?
                    <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '5px' }}>
                        Permaneça nessa tela ate que o download seja feito automaticamente.
                    </Typography>
                    : ''}
                {buttonLoadingMirrorMessage ?
                    <Grid style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ margin: '5px' }}
                            onClick={() => closeLoadingMirror()}>
                            Finalizado!
                        </Button>
                    </Grid>
                    : ''
                }
            </Paper>

        </ContentHeader>
    )
}
